

































































import { Component } from 'vue-property-decorator';
import DialogDailyReport from '@/components/ViewComponent/Attendance/DialogDailyReport.vue';
import ClockIcon from '@/components/Helper/Icon/Svg/ClockIcon.vue';
import WorkingTimeMixin from '@/mixin/WorkingTime/WorkingTimeMixin';
import TimeStamp from '@/components/ViewComponent/Attendance/TimeStamp.vue';
import { StaffEntity } from '@/entities/staff.entity';
import { mapGetters } from 'vuex';

type WorkingTimeActions =
  | 'checkin'
  | 'checkout'
  | 'pauseWorking'
  | 'continueWorking';

@Component<AttendanceManagement>({
  components: {
    TimeStamp,
    ClockIcon,
    DialogDailyReport,
  },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class AttendanceManagement extends WorkingTimeMixin {
  show = false;
  loading = false;
  currentStaff!: StaffEntity;

  get isShowButtonStartWorking(): boolean {
    return this.currentStaff.checkInTime;
  }
  get isShowButtonBreakTime(): boolean {
    return !this.currentStaff.isPause;
  }
  async callActionAndShowDialog(action: WorkingTimeActions): Promise<void> {
    await this[action]();
    this.show = true;
  }
}
